exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".resourceSelection .modal-dialog .modal-body {\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column; }\n  .resourceSelection .modal-dialog .modal-body table tr {\n    cursor: pointer; }\n\n.resourceSelection .searchBarContainer {\n  margin-bottom: 15px; }\n\n.resourceSelection .no-resources-msg {\n  margin: 20px;\n  text-align: center;\n  padding: 0 20%; }\n", ""]);

// exports
